import React from 'react';

/** Shared page chrome for RobinhoodSpace routes. */
const PageShell = ({ title, subtitle, children, className = '' }) => (
  <div className={`rhs-page ${className}`.trim()}>
    {title && <h1>{title}</h1>}
    {subtitle && <p className="rhs-muted rhs-page-subtitle">{subtitle}</p>}
    {children}
  </div>
);

export default PageShell;
